import {CHECKOUT_MODAL,CHECKOUT_DETAILS,GLOBAL_COUNT,CONTACTUS_MODAL} from 'CheckoutAction';

export var ShowCheckoutModalReducer = (state = false, action) => {
  if (action.type === CHECKOUT_MODAL) {
    return action.payload;
  }
  return state;
}

export var ContactUsModalReducer = (state = false, action) => {
  if (action.type === CONTACTUS_MODAL) {
    return action.payload;
  }
  return state;
}

export var UpdateCheckoutDetailsReducer = (state = {amount:0,description:''}, action) => {
  if (action.type === CHECKOUT_DETAILS) {
    return action.payload;
  }
  return state;
}


export var GlobalCountReducer = (state = {}, action) => {
  if (action.type === GLOBAL_COUNT) {
    return action.payload;
  }
  return state;
}
